import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {DataService} from '../../../../Services/data.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { Title } from '@angular/platform-browser';
import { StorageService } from '../../../../Services/storage.service';
import {DatePipe, DecimalPipe, formatDate} from '@angular/common';
import { FilterPipe } from 'ngx-filter-pipe';
import { AppConfigService } from '../../../../Services/app-config.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { DataExportService } from '../../../../Services/dataExport.service';
import { BsToastService } from '../../../../Services/bs-toast-service';
import { EmailModel } from '../../../../DataModels/email-model';
import { take } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import {Modal} from 'bootstrap';
import { RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
  standalone: false
})
export class InvoicesComponent implements OnInit, AfterViewInit, AfterViewChecked {
  // @ViewChild('EmailContent', { static: false }) EmailContent: ElementRef;

  // gets email data to send to api for mailing
  @ViewChildren('InvoiceForm') FormDocument: QueryList<ElementRef>;
  @ViewChildren('DocId') RecId: QueryList<ElementRef>;
  @ViewChildren('Email2') EmailFromDoc: QueryList<ElementRef>;

  private rptName: string;
  public urlParams: any = [];
  timeOut = 0;
  public vm: any = {
    exportToExcel: true,
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/DD/YYYY',
    report: [],
    request: {
      fromDate: null,
      toDate: null,
      account_id: null,
      entity_id: null,
      location_id: null,
      entity_type_id: null,
      header_id: null,
      batch_id: null,
      company_id: null,
    },
    fromDateError: false,
    toDateError: false,
    dateError: false,
    newBatch: [],
    showSpecificDates: false,
    buttonsDisabled: false,
    showFilters: false,
    d: {
      date: '',
      name: '',
    },
    monthCount: 0,
    subLedger: null,
    locationName: null,
    entity: [],
    entityType: [],
    entityFilter: {
      name: null,
    },
    entityInput: null,
    company: [],
    location: [],
    invoice: [],
    reportTotal: 0,
    reportSubtotal: 0,
    reportTax1Code: '',
    reportTax2Code: '',
    reportTax3Code: '',
    reportTax1Total: 0,
    reportTax2Total: 0,
    reportTax3Total: 0,
    entity_email: '',
    startEntityName: 0,
    startEntity: 0,
    entityName: [],
    email: {
      toemail: null,
      fromemail: this.appConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    invoiceFilter: {
      search_string: null,
    },
    batchFilter: {
      description: null,
    },
    batch: [],
    updateBatch: null,
    showEmail: true,
    batchName: [],
    startBatch: 0,
    startBatchName: 0,
    batchInput: null,
    invoiceName: [],
    startInvoice: 0,
    startInvoiceName: 0,
    invoiceInput: null,
  };
  batchRecvdFlag = false;

  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
  };


  div: HTMLElement;
  emailToSendArray: EmailModel[] = [];
  recIdArray = [];
  emailAddressesFromDocArray = [];
  reportFormatCheckBoxValue = true;
  reportDataToSendInEmail: EmailModel = new EmailModel();
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;
  routedFrom = '';

  constructor(
    private route: ActivatedRoute,
    public tableDataService: DataService,
    public dateFilter: DateFilterService,
    private titleService: Title,
    public localStorage: StorageService,
    private router: Router,
    // public aEmail: EmailService,
    public notification: BsToastService,
    public excelExporter: DataExportService,
    public appConfig: AppConfigService,
    public prevUrl: RoutingTrackerService,
    private confirmDialogService: ConfirmDialogService,
    private reportPrint: ReportPrintService
  ) {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  ngOnInit() {
    this.vm.buttonsDisabled = true;
    this.vm.report_format = true;

    this.urlParams = this.route.snapshot.queryParams;

    this.vm.subLedger = this.urlParams.subLedger;
    this.vm.type = this.urlParams.type;

    if (this.urlParams.batch_id ) {
      this.batchRecvdFlag = true;
      this.vm.batch = this.urlParams.batch_id;
      this.vm.batch_id = this.urlParams.batch_id;
    }

    this.vm.request.entity_id = this.urlParams.entity_id;

    let hasUrlDates = false;
    if (this.urlParams.fromDate !== undefined) {
      this.vm.request.fromDate = this.urlParams.fromDate;
      this.vm.showSpecificDates = true;
      hasUrlDates = true;
    }
    if (this.urlParams.toDate !== undefined) {
      this.vm.request.toDate = this.urlParams.toDate;
      this.vm.showSpecificDates = true;
      hasUrlDates = true;
    }

    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      this.newDateFilter(new Date(), new Date());
      const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }

    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

    this.rptName = $localize`:Invoices @@invoices:Invoices`;
    this.FilterOptionsInit().then(() => {
      if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate) {
        this.update();
      }
    });
  }

  ngAfterViewInit() {
    // Normalize title based on subLedger as requested
    const sub = (this.vm?.subLedger || '').toString().toLowerCase();
    let normalizedReportName = '';

    switch (sub) {
      case 'so':
        normalizedReportName = $localize`:Sales Orders @@salesOrders:Sales Orders`;
        break;
      case 'po':
        normalizedReportName = $localize`:Purchase Orders @@purchaseOrders:Purchase Orders`;
        break;
      case 'ss':
        // Sales Shipments should be titled "Shipments" per requirement
        normalizedReportName = $localize`:Shipments @@shipments:Shipments`;
        break;
      case 'ps':
        // Purchase Shipments should be titled "Receiving" per requirement
        normalizedReportName = $localize`:Receiving @@receiving:Receiving`;
        break;
      case 'ar':
        normalizedReportName = $localize`:Receivable Invoices @@receivableInvoices:Receivable Invoices`;
        break;
      case 'ap':
        normalizedReportName = $localize`:Payable Invoices @@payableInvoices:Payable Invoices`;
        break;
      default:
        normalizedReportName = $localize`:Invoices @@invoices:Invoices`;
    }

    // Update internal report name and the browser title
    this.rptName = normalizedReportName;
    this.titleService.setTitle(normalizedReportName + ' ' + $localize`:Report @@report:Report`);
  }

  ngAfterViewChecked() {
    // No-op: email/print HTML is now built on demand via buildPrintHtml()
  }

  async getRecId() {
    // because ng .toArray makes elementref array - I have to build my own regular array - index will match main doc since in same doc
    this.recIdArray = [];
    this.RecId.changes.pipe(take(1)).subscribe((r) => {
      this.RecId.forEach((el, index) => {
        // console.log(`index ${index} :` + el.nativeElement.innerText);
        this.recIdArray.push(el.nativeElement.innerText);
      });
    });
    // console.log('recid array: ' + JSON.stringify(this.recIdArray));
    return this.recIdArray;
  }

  async getEmail() {
    // because ng .toArray makes elementref array - I have to build my own regular array - index will match main doc since in same doc
    this.emailAddressesFromDocArray = [];
    this.EmailFromDoc.changes.pipe(take(1)).subscribe((r) => {
      this.EmailFromDoc.forEach((el, index) => {
        // console.log(`index ${index} :` + el.nativeElement.innerText);
        this.emailAddressesFromDocArray.push(el.nativeElement.innerText);
      });
    });
    // console.log('recid array: ' + JSON.stringify(this.recIdArray));
    return this.emailAddressesFromDocArray;
  }

  // Compute the base report title (without the word "Report") based on subLedger
  private getReportBaseTitle(): string {
    const sub = (this.vm?.subLedger || '').toString().toLowerCase();
    switch (sub) {
      case 'so':
        return $localize`:Sales Orders @@salesOrders:Sales Orders` as any;
      case 'po':
        return $localize`:Purchase Orders @@purchaseOrders:Purchase Orders` as any;
      case 'ss':
        return $localize`:Shipments @@shipments:Shipments` as any;
      case 'ps':
        return $localize`:Receiving @@receiving:Receiving` as any;
      case 'ar':
        return $localize`:Receivable Invoices @@receivableInvoices:Receivable Invoices` as any;
      case 'ap':
        return $localize`:Payable Invoices @@payableInvoices:Payable Invoices` as any;
      default:
        return $localize`:Invoices @@invoices:Invoices` as any;
    }
  }

 setEmailData() {
   const isReport = this.vm.report_format === true;
   if (isReport) {
     // Report mode — open emailer dialog directly, no gate
     this.openEmailModal();
   } else {
     // Invoice form mode — gate with confirm dialog
     const baseTitle = this.getReportBaseTitle();
     this.confirmDialogService.confirmThis(
       [`Email ${baseTitle}`, `This will open the email dialog to send the ${baseTitle}.`, 'Continue?'],
       () => this.openEmailModal(),
       () => {
       }
     );
   }
 }

  private openEmailModal() {
   // Prepare email object and open the local modal instance
   const emailObj = ({} as EmailModel);

   // printing options
   emailObj.print_orientation = '1';
   emailObj.convert_attachment_to = 'pdf';
   emailObj.fromEmail = '';
   emailObj.fromName = 'AcctXErp';
   emailObj.toEmail = '';

   const isReport = this.vm.report_format === true;
   const baseTitle = this.getReportBaseTitle();
   const reportName = isReport ? `${baseTitle} Report` : baseTitle;
   emailObj.Subject = 'AcctXErp ' + reportName;
   emailObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
     + 'Best regards,'
     + '<br><br>'
     + 'AcctXErp'
     + '<br><br>';

    // Build HTML used for print/email
   try {
     if (isReport) {
       emailObj.pdfHtml = this.reportPrint.buildHtml({
         title: reportName,
         contentHtml: this.buildExportHtml(),
         orientation: 'landscape',
         meta: [
           {label: 'Period', value: `${this.vm?.request?.fromDate || ''} to ${this.vm?.request?.toDate || ''}`},
           {label: 'Count', value: String((this.vm.report || []).length)},
         ]
       }) as any;
     } else {
       emailObj.pdfHtml = this.buildPrintHtml(true);
     }
   } catch {
     emailObj.pdfHtml = '' as any;
   }

   // deterministic FileName
   const now = new Date();
   const yyyy = String(now.getFullYear());
   const mm = String(now.getMonth() + 1).padStart(2, '0');
   const dd = String(now.getDate()).padStart(2, '0');
   const fileBase = (isReport ? `${baseTitle} Report` : baseTitle).replace(/\s+/g, ' ').replace(/[^A-Za-z0-9 _-]/g, '');
   emailObj.FileName = `${fileBase}_${yyyy}${mm}${dd}.pdf`;
   emailObj.activity_message = isReport ? `${baseTitle} Report Sent` : `${baseTitle} Sent`;

   this.reportDataToSendInEmail = emailObj;

   // Show the shared Send Email modal directly
   const element = document.getElementById('sendEmailModal') as HTMLElement;
   if (element) {
     const emailModal = new Modal(element);
     emailModal.show();
   }
  }

  // Print the report content using a generated HTML document
  printReport() {
    try {
      if (this.vm.report_format === true) {
        // Report format — use standard ReportPrintService
        const baseTitle = this.getReportBaseTitle();
        const html = this.reportPrint.buildHtml({
          title: `${baseTitle} Report`,
          contentHtml: this.buildExportHtml(),
          orientation: 'landscape',
          meta: [
            {label: 'Period', value: `${this.vm?.request?.fromDate || ''} to ${this.vm?.request?.toDate || ''}`},
            {label: 'Count', value: String((this.vm.report || []).length)},
          ]
        });
        this.reportPrint.printInIframe(html);
      } else {
        // Invoice form format — use existing custom iframe print
        const html = this.buildPrintHtml();
        this.printHtmlInIframe(html);
      }
    } catch (e) {
      console.error('Invoices print failed', e);
      this.notification?.showWarningToast?.('Unable to print Invoices');
    }
  }

  // Build report-format export table HTML from data (no DOM dependency)
  private buildExportHtml(): string {
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const isShipment = this.vm.subLedger === 'ss' || this.vm.subLedger === 'ps';
    const rows: string[] = [];
    const report: any[] = this.vm.report || [];
    for (const r of report) {
      const dateStr = r.header_date ? new Date(r.header_date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : '';
      const docType = r.amount >= 0 ? 'Invoice' : 'Credit';
      const hdrCols = isShipment ? 2 : 6;
      rows.push(`<tr style="font-weight:bold;background:#f6f8fa">
        <td colspan="${hdrCols}">${docType}: ${r.number || ''} &bull; ${r.entity_name || ''}${r.location_name ? ' &bull; ' + r.location_name : ''}${r.description ? ' &bull; ' + r.description : ''}</td>
        <td style="text-align:center">${dateStr}</td>
      </tr>`);
      for (const d of (r.details || [])) {
        const isCtrl = d.control_line === '1';
        const isApAr = (d.account_id || '').toLowerCase() === 'ap' || (d.account_id || '').toLowerCase() === 'ar';
        if (isCtrl) {
          continue;
        }
        rows.push(`<tr style="${isCtrl ? 'color:#999' : ''}">
          <td>${d.item_code || ''}</td>
          <td>${isApAr ? '' : (d.description || '')}</td>
          <td style="text-align:center">${isApAr ? '' : fmt(d.quantity)}</td>
          ${!isShipment ? `<td style="text-align:right">${isApAr ? '' : fmt(d.amount)}</td>` : ''}
          ${!isShipment ? `<td style="text-align:right">${d.debit_credit >= 0 ? fmt(d.debit_credit) : '(' + fmt(d.debit_credit) + ')'}</td>` : ''}
          ${!isShipment ? `<td style="text-align:right"><small>${d.tax_amount_1 ? d.tax_1_code + ': ' + fmt(d.tax_amount_1) : ''}</small></td>` : ''}
          ${!isShipment ? `<td><small>${d.account_id || ''}</small></td>` : ''}
        </tr>`);
      }
    }
    const thStyle = 'background:#f6f8fa;border-bottom:2px solid #d0d7de;padding:6px 8px;font-size:12px;';
    return `<table width="100%" cellpadding="4" cellspacing="0" style="border-collapse:collapse">
      <thead><tr>
        <th style="${thStyle}">Item</th>
        <th style="${thStyle}">Description</th>
        <th style="${thStyle}text-align:center">Qty</th>
        ${!isShipment ? `<th style="${thStyle}text-align:right">Amount</th>` : ''}
        ${!isShipment ? `<th style="${thStyle}text-align:right">Total</th>` : ''}
        ${!isShipment ? `<th style="${thStyle}text-align:right">Taxes</th>` : ''}
        ${!isShipment ? `<th style="${thStyle}">Account</th>` : ''}
      </tr></thead>
      <tbody>${rows.join('')}</tbody>
    </table>`;
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    let content = '';
    if (this.vm.report_format === true) {
      content = this.buildExportHtml();
    } else {
      // Form format: concatenate all invoice forms' HTML
      try {
        const parts: string[] = [];
        if (this.FormDocument && this.FormDocument.length) {
          this.FormDocument.forEach((ref) => {
            const html = (ref?.nativeElement?.outerHTML || '').toString();
            if (html) {
              parts.push(html);
            }
          });
        } else {
          // Fallback: first element with id invoice-form
          const el = document.getElementById('invoice-form');
          if (el) {
            parts.push(el.outerHTML);
          }
        }
        content = parts.join('<hr />');
      } catch {
        content = '';
      }
    }

    // Metadata
    const runAt = new Date().toLocaleString();
    const baseTitle = this.getReportBaseTitle();
    const title = this.vm.report_format ? `${baseTitle} Report` : baseTitle;
    const dateRange = `${this.vm?.request?.fromDate || ''} to ${this.vm?.request?.toDate || ''}`;

    const styles = `
      <style>
        @page { size: landscape; margin: 12mm; }
        html, body { height: 100%; }
        body { font-family: Arial, Helvetica, sans-serif; margin: 18px 24px; color: #111827; }
        h1 { font-size: 20px; margin: 0 0 6px 0; font-weight: 600; }
        .meta { font-size: 12px; color: #6b7280; margin: 6px 0 12px; display: flex; gap: 18px; flex-wrap: wrap; }
        .report-card { border: 1px solid #d0d7de; border-radius: 8px; overflow: hidden; background: #fff; }
        .report-head { border-bottom: 1px solid #d0d7de; padding: 10px 12px; }
        .report-body { padding: 8px 12px 12px; }
        table { width: 100%; border-collapse: collapse; }
        thead th { background: #f6f8fa; border-bottom: 1px solid #d0d7de; font-size: 12px; font-weight: 600; color: #374151; padding: 6px 8px; }
        tbody td { border-bottom: 1px solid #e5e7eb; padding: 6px 8px; font-size: 12px; }
        tbody tr:nth-child(even) td { background: #fbfcfe; }
        @media print { .no-print { display: none !important; } }
      </style>
    `;

    const header = `
      <div class="report-card">
        <div class="report-head">
          <h1>${this.escapeHtml(title)}</h1>
          <div class="meta">
            ${dateRange ? `<span><strong>Period:</strong> ${this.escapeHtml(dateRange)}</span>` : ''}
            <span><strong>Run:</strong> ${this.escapeHtml(runAt)}</span>
          </div>
        </div>
        <div class="report-body">${content}</div>
      </div>
    `;

    return `
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${this.escapeHtml(title)}</title>
          ${styles}
        </head>
        <body>
          ${header}
          <div class="no-print" style="margin-top:8px; font-size:10px; color:#6b7280;">Printed by AcctXERP</div>
        </body>
      </html>
    `;
  }

  // Utility to print HTML in a hidden iframe and clean up afterward
  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || (iframe as any).contentWindow?.document;
    if (!doc) {
      document.body.removeChild(iframe);
      return;
    }

    doc.open();
    doc.write(html);
    doc.close();

    const printAndCleanup = () => {
      try {
        (iframe as any).contentWindow?.focus();
        (iframe as any).contentWindow?.print();
      } finally {
        setTimeout(() => {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, 1000);
      }
    };

    if (doc.readyState === 'complete') {
      setTimeout(printAndCleanup, 250);
    } else {
      (iframe as any).onload = () => setTimeout(printAndCleanup, 250);
    }
  }

  private escapeHtml(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  reportFormat(event: any) {
    // console.log('report format');
    // no need to show form for AP and PS
    if (this.vm.subLedger === 'ap' || this.vm.subLedger === 'ps') {
      event = true;
      this.vm.report_format = event;
      this.reportFormatCheckBoxValue = event;
    } else {
      this.reportFormatCheckBoxValue = event;
      this.vm.report_format = event;
    }
    // this.reportFormatCheckBoxValue = event;
    this.emailToSendArray = [];

    if (this.vm.report.length > 0 && !event) {
      this.getRecId().then();
      this.FormDocument.changes.pipe(take(1)).subscribe(async (r) => {
        await this.getEmail().then();
        // console.log('recid array before subscribe main doc: ' + JSON.stringify(this.recIdArray));
        let noEmailAddress = false;
        let noEmailAddressCount = 0;
        // let noEmailCustomerName = [];

        this.FormDocument.forEach((element, index) => {

          const emailDocObj = {} as EmailModel;

          emailDocObj.fromEmail = '';
          emailDocObj.fromName = 'AcctXErp';
          emailDocObj.header_id = this.recIdArray[index];
          emailDocObj.toEmail = this.emailAddressesFromDocArray[index];
          emailDocObj.body = 'Please see the attached Invoice.' + '<br><br><br>'
            + 'Best regards,'
            + '<br><br>'
            + 'AcctXErp'
            + '<br><br>';
          emailDocObj.Subject = 'AcctXErp Invoice';


          // *** Beware *** will extract EVERY occurrence of the match pattern for email
          // alternate method for getting email address - not fond of it - too many possible fails.
          // emailDocObj.toEmail = element.nativeElement.innerText.match(/[a-zA-Z0-9-_.]+@[a-zA-Z0-9-_.]+/g);

          emailDocObj.pdfHtml = element.nativeElement.outerHTML;
          emailDocObj.includeAttachment = true;

          if (emailDocObj.toEmail) {
            this.emailToSendArray.push(emailDocObj);
          } else {
            noEmailAddress = true;
            noEmailAddressCount += 1;
          }
        });
        // console.log('testArray of email and html: ');
        // console.log(JSON.stringify(this.emailToSendArray));

        if (noEmailAddress) {
          this.notification.showWarningToast(
            noEmailAddressCount + ' item(s) have no To email address and will not be sent if emailed'
          );
        }
      });
    }
  }

  sendInvoices() {
    this.confirmDialogService.confirmThis(
      ['Send Invoices', 'This will email invoices to all customers shown in this report.', 'This action cannot be undone.'],
      () => {
        this.tableDataService
      .putDataByArray('email/PostByArray', this.emailToSendArray)
      .subscribe((resp: HttpResponse<any>) => {
        if (resp != null) {
          // this.notification.showWarningToast(resp.statusText.toString());
        }
        // this.emailToSendArray = [];
      });
      },
      () => {
      }
    );
  }

  exportToExcel() {
    this.vm.buttonsDisabled = true;
    const baseTitle = this.getReportBaseTitle();
    this.excelExporter.exportHtmlToExcel(this.buildExportHtml(), `${baseTitle} Report.xlsx`);
    this.vm.buttonsDisabled = false;
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  async FilterOptionsInit() {
    this.vm.buttonsDisabled = true;
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });
    this.tableDataService
      .getData('location?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
      });
    this.tableDataService
      .getData('entity_type?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entityType = result.Data;
      });
    this.vm.entity = await this.getFilterValues('entity', '?state=active');
    for (const [x, value] of Object.entries(this.vm.entity)) {
      this.vm.entityName.push({ name: this.vm.entity[x].name });
    }
    if (this.vm.request.batch_id) {
      this.tableDataService.getData('t_batch', this.vm.request.batch_id).subscribe((result: any[]) => {
        this.vm.newBatch = result;
      });
    }
    if (this.vm.subLedger == '2') {
      this.vm.subLedger = 'ar';
    } else if (this.vm.subLedger == '4') {
      this.vm.subLedger = 'ap';
    }
    if (!this.vm.subLedger) {
      this.vm.subLedger = 'ar';
    }

    let tempBatchType = null;
    if (this.vm.subLedger === 'ap') {
      tempBatchType = '4';
    } else if (this.vm.subLedger === 'ar') {
      tempBatchType = '2';
    } else if (this.vm.subLedger === 'sq') {
      tempBatchType = '8';
    } else if (this.vm.subLedger === 'so') {
      tempBatchType = '9';
    } else if (this.vm.subLedger === 'po') {
      tempBatchType = '10';
    } else if (this.vm.subLedger === 'ss') {
      tempBatchType = '11';
    } else if (this.vm.subLedger === 'ps') {
      tempBatchType = '12';
    }
    // console.log('before:' + this.urlParams.entity_id);
    // console.log('before:' + JSON.stringify(this.vm.entity));
    if (this.urlParams.entity_id != null || this.urlParams.entity_id != undefined) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        // console.log('outside if:' + this.vm.entity[y].id);
        if (this.vm.entity[y]) {
          // console.log('inside if:' + this.vm.entity[y].id);
          if (this.vm.entity[y].id == this.urlParams.entity_id) {
            this.vm.entityInput = this.vm.entity[y].name;
            this.vm.request.entity_id = this.vm.entity[y].id;
            this.vm.request.entity_email = this.vm.entity[y].email;
            // console.log('break:' + this.vm.entityInput);
            break;
          }
        }
      }
    }
    if (this.urlParams.invoiceId) {
      this.vm.request.header_id = this.urlParams.invoiceId;
    }
    // this.vm.urlParamValid = false;

    if (this.vm.request.toDate && this.vm.request.fromDate && this.vm.request.entity_id) {
      // if (this.vm.urlParamValid) {
      // this.update();
      // }
    }
    this.vm.buttonsDisabled = false;
  }

  async getFilterValues(tablename, param) {
    let values;

    await this.tableDataService.getData(tablename + param + '&pageNumber=0&pageSize=99999')
      .toPromise()
      .then((result: ResponseModel) => {
        const data: any = result.Data;
        values = data;
      });

    return values;
  }

  newDateFilter(toDate, fromDate) {
    this.vm.buttonsDisabled = true;
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
    this.vm.buttonsDisabled = false;
  }

  update() {

   //  console.log('batchflag: ' + this.batchRecvdFlag);

    let tempToDate: any;
    let tempFromDate: any;

    tempToDate = new Date(this.vm.request.toDate);
    tempFromDate = new Date(this.vm.request.fromDate);

    if (this.batchRecvdFlag) {
      this.vm.request.fromDate = new Date();
      this.vm.request.toDate = new Date();
      tempFromDate = new Date(this.vm.request.fromDate);
      tempToDate = new Date(this.vm.request.toDate);
    }

   // console.log('url from: ' + this.vm.request.fromDate);
   // console.log('url to: ' + this.vm.request.toDate);

    let errorDescription = '';
    this.vm.fromDateError = this.vm.toDateError = this.vm.dateError = false;

    if (!this.vm.request.toDate && !this.batchRecvdFlag) {
      errorDescription += $localize`:To Date is required. @@toDateisrequired:To Date is required.`;
      this.vm.toDateError = true;
    }

    if (!this.vm.request.fromDate && !this.batchRecvdFlag) {
      errorDescription += $localize`:From Date is required. @@fromDateisrequired:From Date is required.`;
      this.vm.fromDateError = true;
    }

    if (tempToDate - tempFromDate < 0 && !this.vm.request.batch_id) {
      this.vm.dateError = true;
      errorDescription += $localize`:The To Date must be greater than the From Date. @@theToDatemustbegreaterthantheFromDate:The To Date must be greater than the From Date.`;
    }

    if (errorDescription && !this.batchRecvdFlag) {
      this.notification.showWarningToast(errorDescription);
    } else {
      this.vm.buttonsDisabled = true;
      this.vm.report = [];

      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);

      // a batch was sent in query - use it and ignore other params
      if (this.batchRecvdFlag) {
        this.vm.request.batch_id = this.urlParams.batch_id;
        this.vm.request.toDate = '';
        this.vm.request.fromDate = '';
      }

      // fix dates for sql
      let from = '';
      let to = '';

     // console.log('here');

      if (!this.batchRecvdFlag) {
        // from = new Date(this.vm.request.fromDate).toISOString();
        // to = new Date(this.vm.request.toDate).toISOString();
        from = formatDate(this.vm.request.fromDate, 'yyyy-MM-dd', 'en-US');
        to = formatDate(this.vm.request.toDate, 'yyyy-MM-dd', 'en-US');

        // to = this.dateFilter.GetDateFormat(this.vm.request.toDate);
        // from = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      } else {
        from = this.vm.request.fromDate;
        to = this.vm.request.toDate;
      }

      let batchType = '';
      if (this.vm.subLedger === 'ap') {
        batchType = '4';
      } else if (this.vm.subLedger === 'ar') {
        batchType = '2';
      } else if (this.vm.subLedger === 'sq') {
        batchType = '8';
      } else if (this.vm.subLedger === 'so') {
        batchType = '9';
      } else if (this.vm.subLedger === 'po') {
        batchType = '10';
      } else if (this.vm.subLedger === 'ss') {
        batchType = '11';
      } else if (this.vm.subLedger === 'ps') {
        batchType = '12';
      }

      const urlParamsJson = {
        fromDate: !this.vm.request.batch_id ? from : '',
        toDate: !this.vm.request.batch_id ? to : '',
        subLedger: this.vm.subLedger,
        batchType: batchType,
        entity_id: this.vm.request.entity_id,
        location_id: this.vm.request.location_id,
        company_id: this.vm.request.company_id,
        entity_type_id: this.vm.request.entity_type_id,
        // header_id: this.vm.request.batch_id,
        batch_id: this.vm.request.batch_id ? this.vm.request.batch_id : '',
      };

      const urlParams: string = this.encodeQueryData(urlParamsJson);
      // console.log('query: ' + urlParams);

      this.tableDataService.getData('InvoiceReport', '?' + urlParams).subscribe((result) => {
        this.vm.report = result;
        // console.log(JSON.stringify(this.vm.report));
        if (!this.vm.report.length) {
          this.notification.showWarningToast('No data matching selection criteria');
          this.vm.buttonsDisabled = false;
          return;
        }
        this.calcTotals();
        this.vm.showFilters = false;
        this.vm.buttonsDisabled = false;
        this.reportFormat(this.reportFormatCheckBoxValue);
      });
    }
  }

  calcTotals() {
    this.vm.reportTotal = 0;
    this.vm.reportSubtotal = 0;
    this.vm.reportTax1Code = '';
    this.vm.reportTax2Code = '';
    this.vm.reportTax3Code = '';
    this.vm.reportTax1Total = 0;
    this.vm.reportTax2Total = 0;
    this.vm.reportTax3Total = 0;
    let reverse = -1;
    if (this.vm.subLedger === 'ap') {
      reverse = 1;
    }

    for (const [x, value] of Object.entries(this.vm.report)) {
      this.vm.reportSubtotal += this.vm.report[x].amount;
      this.vm.reportTotal += this.vm.report[x].amount;
      this.vm.report[x].tax_total_1 = 0;
      this.vm.report[x].tax_total_2 = 0;
      for (const [y, value2] of Object.entries(this.vm.report[x].details)) {
        if (this.vm.reportTax1Code === '') {
          this.vm.reportTax1Code = this.vm.report[x].details[y].tax_1_code;
          this.vm.reportTax1Total += this.vm.report[x].details[y].tax_amount_1;
        } else if (this.vm.reportTax1Code === this.vm.report[x].details[y].tax_1_code) {
          this.vm.reportTax1Total += this.vm.report[x].details[y].tax_amount_1;
        } else if (this.vm.reportTax1Code === this.vm.report[x].details[y].tax_2_code) {
          this.vm.reportTax1Total += this.vm.report[x].details[y].tax_amount_2;
        }
        if (this.vm.reportTax2Code === '') {
          this.vm.reportTax2Code = this.vm.report[x].details[y].tax_2_code;
          this.vm.reportTax2Total += this.vm.report[x].details[y].tax_amount_2;
        } else if (this.vm.reportTax2Code === this.vm.report[x].details[y].tax_2_code) {
          this.vm.reportTax2Total += this.vm.report[x].details[y].tax_amount_2;
        } else if (this.vm.reportTax2Code === this.vm.report[x].details[y].tax_1_code) {
          this.vm.reportTax2Total += this.vm.report[x].details[y].tax_amount_1;
        }

        if (!this.vm.report[x].tax_code_1) {
          this.vm.report[x].tax_code_1 = this.vm.report[x].details[y].tax_1_code;
          this.vm.report[x].tax_total_1 += this.vm.report[x].details[y].tax_amount_1;
        } else if (this.vm.report[x].tax_code_1 === this.vm.report[x].details[y].tax_1_code) {
          this.vm.report[x].tax_total_1 += this.vm.report[x].details[y].tax_amount_1;
        } else if (this.vm.report[x].tax_code_1 === this.vm.report[x].details[y].tax_2_code) {
          this.vm.report[x].tax_total_1 += this.vm.report[x].details[y].tax_amount_2;
        }
        if (!this.vm.report[x].tax_code_2) {
          this.vm.report[x].tax_code_2 = this.vm.report[x].details[y].tax_2_code;
          this.vm.report[x].tax_total_2 += this.vm.report[x].details[y].tax_amount_2;
        } else if (this.vm.report[x].tax_code_2 === this.vm.report[x].details[y].tax_2_code) {
          this.vm.report[x].tax_total_2 += this.vm.report[x].details[y].tax_amount_2;
        } else if (this.vm.report[x].tax_code_2 === this.vm.report[x].details[y].tax_1_code) {
          this.vm.report[x].tax_total_2 += this.vm.report[x].details[y].tax_amount_1;
        }
        this.vm.reportTotal += this.vm.report[x].details[y].tax_amount_1 + this.vm.report[x].details[y].tax_amount_2;
      }
    }
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom == undefined) {
      window.close();
    } else {
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.request = {
      fromDate: null,
      toDate: null,
      account_id: null,
      entity_id: null,
      location_id: null,
      entity_type_id: null,
      header_id: null,
      batch_id: null,
      company_id: null,
    };
    this.vm.report = [];
    this.vm.entityInput = '';
  }

  emailReport(toEmail) {
    // console.log('emailing');
    // let tempPdfHtml = '';
    // if (this.reportFormatCheckBoxValue) {
    //   tempPdfHtml = this.FormDocument..innerHTML;
    // } else {
    //   tempPdfHtml = this.FormDocument.nativeElement.innerHTML;
    // }

    // this.vm.email.toemail = toEmail;
    // this.vm.email.PdfHtml = tempPdfHtml;
    // this.vm.email.Subject = this.vm.subLedger.toUpperCase() + ' ' + this.rptName + ' Report';
    // this.aEmail.sendEmail(this.vm.email);
  }

  updateEntity() {
    this.vm.entity_email = '';
    this.vm.buttonsDisabled = true;
    this.vm.startEntityName = 0;
    // this.localStorage.StorageSet('entity', '');
    this.tableDataService
      .getData('entity', '?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
        this.vm.buttonsDisabled = false;
      });
  }

  updateInvoice() {
    this.vm.buttonsDisabled = true;
    this.vm.startInvoiceName = 0;
    // this.localStorage.StorageSet('invoice', '');
    let tempBatchType = null;

    if (this.vm.subLedger === 'ap') {
      tempBatchType = '4';
      // document.getElementById('payables').classList.add('active');
      // document.getElementById('ap-invoices').classList.add('active');
    } else if (this.vm.subLedger === 'ar') {
      tempBatchType = '2';
      // document.getElementById('receivables').classList.add('active');
      // document.getElementById('ar-invoices').classList.add('active');
    } else if (this.vm.subLedger === 'sq') {
      tempBatchType = '8';
      // document.getElementById('crm').classList.add('active');
      // document.getElementById('sales-quote-report').classList.add('active');
    } else if (this.vm.subLedger === 'so') {
      tempBatchType = '9';
      // document.getElementById('sales').classList.add('active');
      // document.getElementById('sales-order-report').classList.add('active');
    } else if (this.vm.subLedger === 'po') {
      tempBatchType = '10';
      // document.getElementById('purchases').classList.add('active');
      // document.getElementById('purchase-order-report').classList.add('active');
    } else if (this.vm.subLedger === 'ps') {
      tempBatchType = '12';
      // document.getElementById('purchases').classList.add('active');
      // document.getElementById('purchase-shipment-report').classList.add('active');
    } else if (this.vm.subLedger === 'ss') {
      // document.getElementById('sales').classList.add('active');
      // document.getElementById('sales-shipment-report').classList.add('active');
    }

    const entryParamsJson = {
      fromDate: '',
      toDate: '',
      numberOfResults: this.appConfig.maxRecords,
      batchType: tempBatchType,
      search: '',
      unpaidInvoices: '',
      pageNumber: 0,
      pageSize: 999999,
    };

    const entryParams: string = this.encodeQueryData(entryParamsJson);

    this.tableDataService.getData('entry', '?' + entryParams).subscribe((result: ResponseModel) => {
      this.vm.invoice = result.Data;
      this.vm.buttonsDisabled = false;
    });
  }

  updateBatch() {
    this.vm.buttonsDisabled = true;
    this.vm.startBatchName = 0;
    // this.localStorage.StorageSet('batch', '');
    let tempBatchType = null;
    if (this.vm.subLedger === 'ap') {
      tempBatchType = '4';
    } else if (this.vm.subLedger === 'ar') {
      tempBatchType = '2';
    } else if (this.vm.subLedger === 'sq') {
      tempBatchType = '8';
    } else if (this.vm.subLedger === 'so') {
      tempBatchType = '9';
    } else if (this.vm.subLedger === 'po') {
      tempBatchType = '10';
    } else if (this.vm.subLedger === 'ss') {
      tempBatchType = '11';
    } else if (this.vm.subLedger === 'ps') {
      tempBatchType = '12';
    }

    this.tableDataService.getData('t_batch', '?state=active&batchType=' + tempBatchType).subscribe((result) => {
      // this.tableDataService.getData('t_batch', '?state=active').subscribe((result) => {
      this.vm.batch = result;
      this.vm.buttonsDisabled = false;
    });
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id === '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name === entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.entity_email = this.vm.entity[y].email;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  selectBatch(batchName) {
    this.vm.request.batch_id = '';
    if (this.vm.request.batch_id === '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.batch)) {
        if (this.vm.batch[y].description === batchName) {
          this.vm.batchInput = batchName;
          this.vm.request.batch_id = this.vm.batch[y].id;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput === '') {
      this.vm.request.entity_id = undefined;
    } else {
      if (this.FilterObject(this.vm.entity, { name: this.vm.entityInput }).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].name;
        const entityEmail = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].email;
        if (entityId !== '' || entityId !== null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
          this.vm.entity_email = entityEmail;
        } else {
          this.vm.request.entity_id = this.vm.entity_email = undefined;
        }
      } else {
        this.vm.request.entity_id = this.vm.entity_email = undefined;
      }
    }
    if (entityIdStart !== this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  testBatch() {
    const batchIdStart = this.vm.request.batch_id;
    if (!this.vm.batchInput || this.vm.batchInput === '' || this.vm.batchInput === null) {
      this.vm.request.batch_id = undefined;
    } else {
      if (this.FilterObject(this.vm.batch, { description: this.vm.batchInput }).length > 0) {
        const batchId = this.FilterObject(this.vm.batch, { description: this.vm.batchInput }, true)[0].id;
        if (batchId !== '' || batchId !== null) {
          this.vm.request.batch_id = batchId;
        }
      }
    }
    if (batchIdStart !== this.vm.request.batch_id) {
      this.vm.report = [];
    }
  }

  testInvoice() {
    const batchIdStart = this.vm.request.batch_id;
    if (!this.vm.batchInput || this.vm.batchInput === '' || this.vm.batchInput === null) {
      this.vm.request.batch_id = undefined;
    } else {
      if (this.FilterObject(this.vm.batch, { description: this.vm.batchInput }).length > 0) {
        const batchId = this.FilterObject(this.vm.batch, { description: this.vm.batchInput }, true)[0].id;
        if (batchId !== '' || batchId !== null) {
          this.vm.request.batch_id = batchId;
        }
      }
    }
    if (batchIdStart !== this.vm.request.batch_id) {
      this.vm.report = [];
    }
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  selectInvoice(InvoiceId) {}
}
